<template>
    <div class="points-management">
        <div class="page-header">
            <h2>{{ $t('pointsManagement.pageTitle') }}</h2>
        </div>

        <div class="content-wrapper">
            <!-- 左侧信息与列表区域 -->
            <div class="info-section">

                <!-- 站点列表 -->
                <el-card class="list-card">
                    <div slot="header" class="list-card-header">
                        <h3>{{ $t('pointsManagement.pointList') }}</h3>
                        <div class="search-wrapper">
                            <el-input  size="small" v-model="searchKeyword" placeholder="请输入站点名称、描述或坐标进行搜索" clearable
                                @clear="clearSearch" @input="handleSearch" @keyup.enter="handleSearch"
                                style="width: 300px">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                            </el-input>
                            <el-button type="primary" @click="openAddPointDialog" size="small" style="margin-left: 10px;">{{
                                $t('pointsManagement.addPoint') }}</el-button>
                        </div>
                    </div>
                    <el-table :data="paginatedPoints" style="width: 100%" @row-click="selectPoint"
                        :row-class-name="tableRowClassName">
                        <el-table-column prop="name" :label="$t('pointsManagement.pointName')"
                            min-width="120"></el-table-column>
                        <!-- <el-table-column prop="longitude" :label="$t('pointsManagement.longitude')"
                            min-width="100"></el-table-column>
                        <el-table-column prop="latitude" :label="$t('pointsManagement.latitude')"
                            min-width="100"></el-table-column> -->
                        <el-table-column prop="description" :label="$t('pointsManagement.description')"
                            show-overflow-tooltip  min-width="220"></el-table-column>
                        <el-table-column :label="$t('pointsManagement.actions')" width="120" fixed="right">
                            <template slot-scope="scope">
                                <el-button size="mini" @click.stop="editPoint(scope.row)">{{
                                    $t('pointsManagement.editBtn') }}</el-button>
                                <el-button size="mini" type="danger" @click.stop="confirmDelete(scope.row)">{{
                                    $t('pointsManagement.deleteBtn') }}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-wrapper">
                        <el-pagination background layout="total, prev, pager, next" :total="filteredPoints.length"
                            :page-size="pageSize" :current-page.sync="currentPage"
                            @current-change="handleCurrentChange"></el-pagination>
                    </div>
                </el-card>
            </div>

            <!-- 右侧地图区域 -->
            <div class="map-section">
                <div class="map-container">
                    <KingLongMap ref="map" :mapId="'pointsMap'" @DrawPointCompleted="handlePointCompleted"
                        @LoadCompleted="handleMapLoad" />
                </div>
            </div>
        </div>

        <!-- 新增/编辑站点对话框 -->
        <el-dialog :title="currentPoint.id ? $t('pointsManagement.editPoint') : $t('pointsManagement.addPoint')"
            :visible.sync="pointDialogVisible" width="800px" :close-on-click-modal="false">
            <el-form :model="currentPoint" :rules="rules" ref="pointForm" label-width="100px">
                <el-form-item :label="$t('pointsManagement.pointName')" prop="name">
                    <el-input v-model="currentPoint.name"
                        :placeholder="$t('pointsManagement.enterPointName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('pointsManagement.longitude')" prop="longitude">
                    <el-input v-model="currentPoint.longitude" :placeholder="$t('pointsManagement.selectOnMap')"
                        readonly></el-input>
                </el-form-item>
                <el-form-item :label="$t('pointsManagement.latitude')" prop="latitude">
                    <el-input v-model="currentPoint.latitude" :placeholder="$t('pointsManagement.selectOnMap')"
                        readonly></el-input>
                </el-form-item>
                <el-form-item :label="$t('pointsManagement.description')" prop="description">
                    <el-input type="textarea" v-model="currentPoint.description"
                        :placeholder="$t('pointsManagement.enterDescription')"></el-input>
                </el-form-item>
                <el-form-item>
                    <div class="dialog-map-container">
                        <KingLongMap ref="dialogMap" :mapId="'dialogPointsMap'" v-if="pointDialogVisible"
                            @DrawPointCompleted="handleDialogPointCompleted" @LoadCompleted="handleDialogMapLoad" />
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closePointDialog">{{ $t('pointsManagement.cancelBtn') }}</el-button>
                <el-button type="primary" size="small" @click="savePoint" :loading="saving">{{
                    $t('pointsManagement.saveBtn')
                    }}</el-button>

            </div>
        </el-dialog>

        <!-- 删除确认对话框 -->
        <el-dialog :title="$t('pointsManagement.confirmDelete')" :visible.sync="deleteDialogVisible" width="30%">
            <span>{{ $t('pointsManagement.deleteConfirmMsg') }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">{{ $t('pointsManagement.cancelBtn') }}</el-button>
                <el-button type="danger" @click="confirmDeleteAction">{{ $t('pointsManagement.deleteBtn') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import KingLongMap from '@/components/KingLongMap.vue';

export default {
    name: 'PointsManagement',
    components: {
        KingLongMap
    },
    data() {
        return {
            // 表单数据
            currentPoint: {
                id: null,
                name: '',
                longitude: '',
                latitude: '',
                description: ''
            },
            // 表单验证规则
            rules: {
                name: [
                    { required: true, message: this.$t('pointsManagement.nameRequired'), trigger: 'blur' }
                ],
                longitude: [
                    { required: true, message: this.$t('pointsManagement.coordinateRequired'), trigger: 'blur' }
                ],
                latitude: [
                    { required: true, message: this.$t('pointsManagement.coordinateRequired'), trigger: 'blur' }
                ]
            },
            // 模拟数据 - 站点列表
            pointsList: [],
            // 搜索相关
            searchKeyword: '',
            // 分页相关
            currentPage: 1,
            pageSize: 10,
            // 状态标志
            saving: false,
            deleteDialogVisible: false,
            pointDialogVisible: false,
            pointToDelete: null,
            selectedPointId: null
        };
    },
    computed: {
        ...mapState({
            language: state => state.user.language
        }),
        // 搜索过滤后的数据
        filteredPoints() {
            if (!this.searchKeyword.trim()) {
                return this.pointsList;
            }

            const keyword = this.searchKeyword.toLowerCase();
            return this.pointsList.filter(point =>
                point.name.toLowerCase().includes(keyword) ||
                point.description.toLowerCase().includes(keyword) ||
                point.longitude.includes(keyword) ||
                point.latitude.includes(keyword)
            );
        },
        // 分页后的数据
        paginatedPoints() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredPoints.slice(startIndex, endIndex);
        }
    },
    mounted() {
        // 初始化模拟数据
        this.initMockData();
    },
    methods: {
        // 处理搜索
        handleSearch() {
            this.currentPage = 1; // 重置到第一页
        },

        // 清除搜索
        clearSearch() {
            this.searchKeyword = '';
            this.currentPage = 1;
        },

        // 打开添加站点对话框
        openAddPointDialog() {
            this.resetForm();
            this.pointDialogVisible = true;
            if (this.$refs.dialogMap) {
                this.$refs.dialogMap.drawPoint();
            }
            // 主地图不再自动进入绘制模式，改由对话框地图处理
        },

        // 关闭站点对话框
        closePointDialog() {
            this.pointDialogVisible = false;
            if (this.$refs.dialogMap) {
                this.$refs.dialogMap.cancelDraw();
            }
        },

        // 开始绘制点（保持兼容性）
        startDrawPoint() {
            this.openAddPointDialog();
        },

        // 取消绘制（保持兼容性）
        cancelDraw() {
            if (this.$refs.map) {
                this.$refs.map.cancelDraw();
            }
        },

        // 初始化模拟数据
        initMockData() {
            this.pointsList = [
                {
                    id: 1,
                    name: '站点A',
                    longitude: '115.52873841196535',
                    latitude: '40.141636379850915',
                    description: '这是一个模拟的站点A，位于北京市中心'
                },
                {
                    id: 2,
                    name: '站点B',
                    longitude: '116.404089',
                    latitude: '39.915824',
                    description: '这是一个模拟的站点B，位于北京东城区'
                },
                {
                    id: 3,
                    name: '站点C',
                    longitude: '116.380529',
                    latitude: '39.916323',
                    description: '这是一个模拟的站点C，位于北京西城区'
                },
                {
                    id: 4,
                    name: '站点D',
                    longitude: '116.397929',
                    latitude: '39.885665',
                    description: '这是一个模拟的站点D，位于北京海淀区'
                },
                {
                    id: 5,
                    name: '站点E',
                    longitude: '116.444456',
                    latitude: '39.900067',
                    description: '这是一个模拟的站点E，位于北京朝阳区'
                }
            ];
            // 在地图上显示模拟数据标记
            this.$nextTick(() => {
                this.displayPointsOnMap();
            });
        },

        // 处理地图加载完成
        handleMapLoad() {
            console.log('地图加载完成');
            this.displayPointsOnMap();
        },

        // 在地图上显示所有站点
        displayPointsOnMap() {
            if (!this.$refs.map || !this.$refs.map.map) return;

            // 清除所有标记
            this.$refs.map.clearMarkers();

            // 添加所有站点标记
            this.pointsList.forEach(point => {
                this.$refs.map.addMarker(
                    point.id,
                    point.name,
                    parseFloat(point.longitude),
                    parseFloat(point.latitude),
                    null,
                    () => {
                        this.selectPoint(point);
                    }
                );
            });
        },

        // 开始绘制点
        startDrawPoint() {
            this.resetForm();
            if (this.$refs.map) {
                this.$refs.map.drawPoint();
            }
        },

        // 取消绘制
        cancelDraw() {
            if (this.$refs.map) {
                this.$refs.map.cancelDraw();
            }
        },

        // 处理绘制点完成事件 - 主地图
        handlePointCompleted(lng, lat) {
            this.currentPoint.longitude = lng.toString();
            this.currentPoint.latitude = lat.toString();
            this.$message.success(this.$t('pointsManagement.pointSelected'));
        },

        // 处理绘制点完成事件 - 对话框地图
        handleDialogPointCompleted(lng, lat) {
            this.currentPoint.longitude = lng.toString();
            this.currentPoint.latitude = lat.toString();
            this.$message.success(this.$t('pointsManagement.pointSelected'));
        },

        // 处理对话框地图加载完成
        handleDialogMapLoad() {
            console.log('对话框地图加载完成');
            if (this.currentPoint.longitude && this.currentPoint.latitude) {
                // 设置地图中心到当前站点位置
                this.$refs.dialogMap.setCenter(parseFloat(this.currentPoint.longitude), parseFloat(this.currentPoint.latitude));
                // 添加当前站点的标记
                this.$refs.dialogMap.addMarker(
                    this.currentPoint.id || 'current',
                    this.currentPoint.name || '当前站点',
                    parseFloat(this.currentPoint.longitude),
                    parseFloat(this.currentPoint.latitude)
                );
            }
            // 如果是新增站点，启动绘制模式
            if (!this.currentPoint.id) {
                this.$refs.dialogMap.drawPoint();
            }
        },

        // 重置表单
        resetForm() {
            if (this.$refs.pointForm) {
                this.$refs.pointForm.resetFields();
            }
            this.currentPoint = {
                id: null,
                name: '',
                longitude: '',
                latitude: '',
                description: ''
            };
            this.selectedPointId = null;
        },

        // 保存站点
        savePoint() {
            this.$refs.pointForm.validate((valid) => {
                if (valid) {
                    this.saving = true;

                    // 模拟API调用延迟
                    setTimeout(() => {
                        if (this.currentPoint.id) {
                            // 编辑现有站点
                            const index = this.pointsList.findIndex(p => p.id === this.currentPoint.id);
                            if (index !== -1) {
                                this.pointsList.splice(index, 1, { ...this.currentPoint });
                                this.$message.success(this.$t('pointsManagement.updateSuccess'));
                            }
                        } else {
                            // 添加新站点
                            const newPoint = {
                                ...this.currentPoint,
                                id: Date.now() // 使用时间戳作为临时ID
                            };
                            this.pointsList.push(newPoint);
                            this.$message.success(this.$t('pointsManagement.addSuccess'));
                        }

                        // 更新地图上的标记
                        this.displayPointsOnMap();

                        // 关闭对话框并取消绘制
                        this.pointDialogVisible = false;
                        if (this.$refs.dialogMap) {
                            this.$refs.dialogMap.cancelDraw();
                        }
                        this.saving = false;
                    }, 500);
                }
            });
        },

        // 编辑站点
        editPoint(point) {
            this.currentPoint = { ...point };
            this.selectedPointId = point.id;
            this.pointDialogVisible = true;
            //在编辑框中设置地图中心到当前站点位置
            this.$nextTick(() => {
                if (this.$refs.dialogMap) {
                    this.$refs.dialogMap.setCenter(parseFloat(this.currentPoint.longitude), parseFloat(this.currentPoint.latitude));
                    // 添加当前站点的标记
                    this.$refs.dialogMap.addMarker(
                        this.currentPoint.id || 'current',
                        this.currentPoint.name || '当前站点',
                        parseFloat(this.currentPoint.longitude),
                        parseFloat(this.currentPoint.latitude)
                    );
                }
            });

        },

        // 选择站点 - 只在地图上显示，不打开编辑对话框
        selectPoint(point) {
            // 更新选中状态
            this.selectedPointId = point.id;

            // 将地图中心设置到选中的站点
            if (this.$refs.map) {
                this.$refs.map.setCenter(parseFloat(point.longitude), parseFloat(point.latitude));
            }
        },

        // 确认删除
        confirmDelete(point) {
            this.pointToDelete = point;
            this.deleteDialogVisible = true;
        },

        // 确认删除操作
        confirmDeleteAction() {
            if (this.pointToDelete) {
                const index = this.pointsList.findIndex(p => p.id === this.pointToDelete.id);
                if (index !== -1) {
                    this.pointsList.splice(index, 1);
                    this.$message.success(this.$t('pointsManagement.deleteSuccess'));

                    // 更新地图标记
                    this.displayPointsOnMap();

                    // 如果删除的是当前编辑的站点，重置表单
                    if (this.currentPoint.id === this.pointToDelete.id) {
                        this.resetForm();
                    }
                }
            }
            this.deleteDialogVisible = false;
            this.pointToDelete = null;
        },

        // 删除当前站点
        deletePoint() {
            this.confirmDelete(this.currentPoint);
            this.pointDialogVisible = false;
        },

        // 处理分页变化
        handleCurrentChange(page) {
            this.currentPage = page;
        },

        // 表格行样式
        tableRowClassName({ row }) {
            return row.id === this.selectedPointId ? 'selected-row' : '';
        }
    }
};
</script>

<style scoped>
.points-management {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.content-wrapper {
    display: flex;
    height: calc(100% - 80px);
    gap: 20px;
}

.map-section {
    width: 60%;
    display: flex;
    flex-direction: column;
}

.map-container {
    flex: 1;
    min-height: 500px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

.info-section {
    width: 40%;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-card {
    flex-shrink: 0;
}

.list-card {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.list-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
}

.search-wrapper {
    display: flex;
    align-items: center;
}

.list-card-header h3 {
    margin: 0;
}

.el-table {
    flex: 1;
    overflow: auto;
}

.pagination-wrapper {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}

.selected-row {
    background-color: #e6f7ff;
}

/* 对话框中的地图样式 */
.dialog-map-container {
    height: 300px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    margin-top: 10px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .content-wrapper {
        flex-direction: column;
    }

    .map-section,
    .info-section {
        width: 100%;
    }

    .map-container {
        min-height: 400px;
    }
}
</style>

<style>
/* 全局样式 */
.pointsManagement .el-card__header {
    padding: 10px 20px;
}
</style>